import { render } from "./tarif_plan.vue?vue&type=template&id=1cd61018&scoped=true"
import script from "./tarif_plan.vue?vue&type=script&lang=js"
export * from "./tarif_plan.vue?vue&type=script&lang=js"

import "./tarif_plan.vue?vue&type=style&index=0&id=1cd61018&scoped=true&lang=css"

import exportComponent from "/Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd61018"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../../../Volumes/Whisper/Development/projects/sid/ui/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QCheckbox,QDialog,QCard,QCardSection,QInput,QCardActions});qInstall(script, 'directives', {ClosePopup});
